import {
	Component,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "../common-imports"
import { Modalable } from "@app/Modalable"
import { GenButtonGroupComponent } from "@app/gen-inputs/gen-button-group/gen-button-group.component"
import {
	CancelBtnComponent,
	Check,
	PatientModalComponent,
	SpinOrContent,
	TableWrapComponent,
} from "@app/utils/utils.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { DateFormatPipe } from "@app/utils/date-format.pipe"

@Component({
	selector: "app-sub-user-patients",
	imports: [
		COMMON_IMPORTS,
		GenButtonGroupComponent,
		TableWrapComponent,
		SpinOrContent,
		Check,
		PatientModalComponent,
		LangValPipe,
		DateFormatPipe,
		CancelBtnComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./sub-user-patients.component.html",
})
export class SubUserPatientsComponent extends Modalable {
	rows: any[] = []
	rowsShown: any[] = []
	@Input() inputRow: any = null
	optStatus: any = "yes"
	objsubStatus: any = "yes"
	userActiveStatus: any = "yes"
	isLoading: boolean = false
	checkedIds: number[] = []
	isDeactivatingAll: boolean = false

	async ngOnInit() {
		this.isDeactivatingAll = false
		this.checkedIds = []
		this.isLoading = true
		this.rows = await this.apiService.post("get_patients_sub_users")
		this.rows.forEach((row) => {
			const patient = this.store.searchSiteDataItem(row.item_id, ["patients"])
			row.name = patient?.name || ""
			row.status = patient?.status || ""
			row.patientActive = patient?.active || ""
			row.userActive =
				this.store.searchSiteDataItem(row.user_id, ["sub_users"])?.active ||
				"yes"
		})
		this.filterRows()
		this.isLoading = false
	}
	check(id: number) {
		this.checkedIds = this.checkedIds.includes(id)
			? this.checkedIds.filter((i) => i !== id)
			: [...this.checkedIds, id]
	}
	async deactivateAll() {
		if (!this.checkedIds.length) {
			return
		}
		this.isDeactivatingAll = true
		await this.apiService.post("delete_assoc_multi", { ids: this.checkedIds })
		this.rows
			.filter((row) => this.checkedIds.includes(row.id))
			.forEach((row) => {
				this.store.deletePatientAssoc(row.patient.id, row.user_id)
			})
		this.ngOnInit()
	}
	filterRows() {
		const dispRows: any[] = []
		let subTotalRow: any = this.getNewSubTotalRow(0)

		this.rowsShown = this.rows
			.filter((it) => {
				return this.optStatus == "-1" || it?.patientActive == this.optStatus
			})
			.filter((it) => {
				return this.objsubStatus == "-1" || it?.active == this.objsubStatus
			})
			.filter((it) => it.userActive == this.userActiveStatus)

		if (this.inputRow) {
			this.rowsShown = this.rowsShown.filter(
				(it) => it.user_id == this.inputRow.id
			)
		}

		this.rowsShown.forEach((row) => {
			if (!subTotalRow.user_id) {
				subTotalRow.user_id = row.user_id
			}
			if (subTotalRow.user_id != row.user_id) {
				subTotalRow.name =
					this.lang.getVal("total") +
						" " +
						this.store.searchSiteDataItem(subTotalRow.user_id, ["sub_users"])
							?.name || ""
				subTotalRow.status =
					this.lang.getVal("total") +
					": " +
					subTotalRow.total +
					". " +
					this.lang.getVal("patients") +
					": " +
					subTotalRow.patient +
					". " +
					this.lang.getVal("inquirers") +
					": " +
					subTotalRow.inquirer +
					". "
				dispRows.push(subTotalRow)
				subTotalRow = this.getNewSubTotalRow(row.user_id)
			}

			subTotalRow.total++
			if (row.status == "patient") {
				subTotalRow.patient++
			}
			if (row.status == "inquirer") {
				subTotalRow.inquirer++
			}

			dispRows.push(row)
		})
		if (dispRows.length) {
			subTotalRow.name =
				this.lang.getVal("total") +
					" " +
					this.store.searchSiteDataItem(subTotalRow.user_id, ["sub_users"])
						?.name || ""
			subTotalRow.status =
				this.lang.getVal("total") +
				": " +
				subTotalRow.total +
				". " +
				this.lang.getVal("patients") +
				": " +
				subTotalRow.patient +
				". " +
				this.lang.getVal("inquirers") +
				": " +
				subTotalRow.inquirer +
				". "
			dispRows.push(subTotalRow)
		}

		this.rowsShown = dispRows
	}

	async deactivate(row: any) {
		this.isLoading = true
		const { user_id, patient } = row

		const item = { user_id, item_id: patient.id, item_type: "patient" }
		await this.apiService.post("delete_assoc", item)
		this.store.deletePatientAssoc(patient.id, user_id)

		// const res:any=await this.apiService.save_gen_field("patients", id,"active" , "no");
		// this.store.updGenItemRowField("patients", id, "active", "no");
		this.rowsShown = []
		this.ngOnInit()
	}

	getNewSubTotalRow(user_id: number = 0) {
		return { user_id, total: 0, patient: 0, inquirer: 0, isSubTotal: true }
	}

	async downloadReport() {
		//request to download report from api
		this.store.downloadToastFunc(async () => {
			const res: any = await this.apiService.download(
				"get_patients_sub_users",
				{ ...this.rowsShown, dlExcel: true }
			)
			this.apiService.downloadFile(res, "patients.xlsx")
		})
	}

	async print() {
		//print this report by creating a new document, opening it, and requesting the winodw to print
		let html = document.getElementById("section-to-print")?.innerHTML

		this.store.printWindow(`
		<html>
		<style type='text/css'>${this.store.getPrintStyle()}</style>
		<body onload="window.print()" style="direction:rtl">
		${html}
		</body>
		</html>`)
	}
}
